/*
 * WaWiWertkorrekturApp.jsx
 *
 * Created by Dr. Maximillian Dornseif 2021-11-28 in huWaWi3 24.5.4
 * Copyright (c) 2021, 2022 HUDORA GmbH
 */

import gql from 'graphql-tag'
import React from 'react'

import { WERTKORREKTUR_FRAGMENT } from '../fragments'
import { KindPage } from '../lib/components/KindPage'

export const IcWertkorrekturenApp = (props) => {
  return (
    <KindPage
      basePath={'/ic'}
      componentPath={'wertkorrektur'}
      schemaName={'HwIcWertkorrektur'}
      title={'Wertkorrekturen'}
      listQuery={WERTKORREKTUR_LIST_QUERY}
      entityQuery={WERTKORREKTUR_QUERY}
    ></KindPage>
  )
}

export const WERTKORREKTUR_LIST_QUERY = gql`
  query Wertkorrekturen($cursor: String) {
    nodes: hwIcWertkorrekturPages(after: $cursor) {
      edges {
        cursor
        node {
          ...wertkorrekturFragment
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
  ${WERTKORREKTUR_FRAGMENT}
`

const WERTKORREKTUR_QUERY = gql`
  query Wertkorrektur($nr: ID!) {
    entity: hwIcWertkorrektur(designator: $nr) {
      ...wertkorrekturFragment
    }
  }
  ${WERTKORREKTUR_FRAGMENT}
`
